<app-modal-header title="Change Password" (closeModal)="closeDialog()"></app-modal-header>
<div class="bg-white flex flex-col items-center justify-center">
    <p class="text-gray-dark text-center p-3">{{ 'Your new password should be different from previous passwords' }}</p>
    <div class="w-full">
        <!-- Form -->
        <form
                (ngSubmit)="submitForm(form.value)"
                [formGroup]="form"
                autocomplete="off"
                novalidate
                class="w-full"
        >
            <mat-form-field appearance="outline">
                <mat-label>{{ 'Old Password' | concat | translate }}</mat-label>
                <input [type]="showPassword ? 'password' : 'text'" matInput formControlName="oldPassword">
                <button type="button" mat-icon-button matSuffix (click)="showPassword = !showPassword"
                        [attr.aria-label]="'Hide'"
                        [attr.aria-pressed]="showPassword">
                    <mat-icon class="material-icons-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}
                    </mat-icon>
                </button>
                <mat-error>
          <span
                  *ngIf="!form.get('oldPassword')?.valid && form.get('oldPassword')?.touched">
              {{ 'Field is required' | concat | translate }}
          </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>{{ 'New Password' | concat | translate }}</mat-label>
                <input [type]="showPassword2 ? 'password' : 'text'" matInput formControlName="newPassword">
                <button type="button" mat-icon-button matSuffix (click)="showPassword2 = !showPassword2"
                        [attr.aria-label]="'Hide'"
                        [attr.aria-pressed]="showPassword2">
                    <mat-icon class="material-icons-outlined">{{ showPassword2 ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
                <mat-error>
    <span *ngIf="form.get('newPassword')?.hasError('required') && form.get('newPassword')?.touched">
      {{ 'Field is required' | concat | translate }}
    </span>
                    <span *ngIf="form.hasError('passwordMismatch') && form.get('newPassword')?.touched">
      {{ 'Passwords must match. Please ensure both passwords are identical.' | concat | translate }}
    </span>
                </mat-error>
            </mat-form-field>

            <div class="w-full mb-3">
                <button routerLink="/login"  [disabled]="!form.valid || loading" class="w-full"
                        mat-raised-button color="primary">
                    {{ 'Reset Password' }}
                </button>
            </div>
        </form>

    </div>
</div>
